import React, { memo, useEffect, useState } from 'react';
import { Menu, Popover, Button } from 'antd';
import JwtDecode from 'jwt-decode';
import Shortcut from '@tekion/tekion-components/src/molecules/Accessibility/Shortcuts';
import './GetHelp.scss';
import GetHelpItem from './GetHelpItem';
import { isEmpty, renderIfElse } from '../../utils/helper';
import { getModuleName, initializeTapChat } from '../../utils/tapchat';
import CreateTicket from '../../molecules/CreateTicket';
import Loader from '../Loader';
const GetHelpMenu = _ref => {
  let {
    brandId,
    isTapChatChunkFetched,
    handleMenuClick
  } = _ref;
  return /*#__PURE__*/React.createElement(Menu, {
    className: "gethelp-menu",
    selectedKeys: [],
    onClick: handleMenuClick
  }, /*#__PURE__*/React.createElement(Menu.Item, {
    key: "chatWithSupport"
  }, renderIfElse(!isTapChatChunkFetched || !brandId, () => /*#__PURE__*/React.createElement("div", {
    className: "chatmenu-loading"
  }, /*#__PURE__*/React.createElement(Loader, null)), () => /*#__PURE__*/React.createElement(GetHelpItem, {
    title: __('Chat with Support'),
    description: __('Chat with support for any assistance'),
    icon: "icon-chat2"
  }))), /*#__PURE__*/React.createElement(Menu.Divider, null), /*#__PURE__*/React.createElement(Menu.Item, {
    key: "addNewTicket"
  }, /*#__PURE__*/React.createElement(GetHelpItem, {
    title: __('Add New Ticket'),
    description: __('Create new ticket for any assistance'),
    icon: "icon-details"
  })));
};
const GetHelp = _ref2 => {
  let {
    isPartnerSite,
    chatS3Url,
    fetchChatConfig,
    getChatAccessToken,
    apiBaseUrl,
    userDetails
  } = _ref2;
  const [brandId, setBrandId] = useState('');
  const [showPopover, setShowPopover] = useState(false);
  const [isTapChatChunkFetched, setIsTapChatChunkFetched] = useState(false);
  const [isTapChatChunkFetching, setIsTapChatChunkFetching] = useState(false);
  const [showCustomTapChat, setShowCustomTapChat] = useState(false);
  const [showAddTicket, setShowAddTicket] = useState(false);
  useEffect(() => {
    if (chatS3Url) {
      if (isEmpty(window.TAP_CHAT)) {
        initializeTapChat(chatS3Url, () => {
          window.TAP_CHAT.initialize({
            getAccessToken: chatAuthFunction
          });
          setIsTapChatChunkFetched(true);
          setIsTapChatChunkFetching(false);
        });
      }
    }
  }, [chatS3Url]);
  useEffect(() => {
    if (isTapChatChunkFetched && showCustomTapChat) {
      onSelectBrand('leave-message-form');
      setShowCustomTapChat(false);
    }
  }, [isTapChatChunkFetched, showCustomTapChat]);
  const getTapChatChunks = visible => {
    if (visible && !isPartnerSite && isEmpty(chatS3Url) && !isTapChatChunkFetching && !isTapChatChunkFetched) {
      setIsTapChatChunkFetching(true);
      fetchChatConfig(apiBaseUrl);
    }
  };
  const chatAuthFunction = callback => {
    const userInfo = {
      email: userDetails.email,
      tenant: 'tap',
      dealer: 'tap'
    };
    return getChatAccessToken(apiBaseUrl, userInfo, callback);
  };
  const onPressHotKey = () => {
    if (isTapChatChunkFetched) {
      onSelectBrand('leave-message-form');
    } else if (!isTapChatChunkFetching) {
      setShowCustomTapChat(true);
      getTapChatChunks(true);
    }
  };
  const onSelectBrand = function () {
    let viewRoute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    window.TAP_CHAT.open({
      user: {
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        email: userDetails.email
      },
      tags: ['tenantId:tap', 'dealerId:tap', "userId:".concat(userDetails.email), "module:".concat(getModuleName())],
      brandId,
      viewRoute
    });
  };
  const handleMenuClick = e => {
    if (e.key === 'addNewTicket') {
      setShowAddTicket(true);
    } else {
      onSelectBrand();
    }
    setShowPopover(false);
  };
  const handleOnVisibleChange = visible => {
    setShowPopover(visible);
    getTapChatChunks(true);
    if (visible && isEmpty(brandId)) {
      chatAuthFunction(token => {
        const {
          brand_id: tokenBrandId
        } = JwtDecode(token);
        setBrandId(tokenBrandId);
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "gethelp-container"
  }, /*#__PURE__*/React.createElement(Popover, {
    className: "gethelp-popover-container",
    overlayClassName: "gethelp-popover-overlay-container",
    placement: "bottomRight",
    content: /*#__PURE__*/React.createElement(GetHelpMenu, {
      brandId: brandId,
      isTapChatChunkFetched: isTapChatChunkFetched,
      handleMenuClick: handleMenuClick
    }),
    trigger: "click",
    visible: showPopover,
    onVisibleChange: handleOnVisibleChange
  }, /*#__PURE__*/React.createElement(Button, {
    className: "gethelp-button",
    type: "primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "tap-icon-headset"
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  })), __('Get Help')), /*#__PURE__*/React.createElement(Button, {
    className: "gethelp-popover-button",
    type: "primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-chevron-down"
  }))), showAddTicket && /*#__PURE__*/React.createElement(CreateTicket, {
    apiBaseUrl: apiBaseUrl,
    onClose: setShowAddTicket
  }), /*#__PURE__*/React.createElement(Shortcut, {
    held: [['Meta'], ['Control']],
    ordered: ['d'],
    onMatch: onPressHotKey,
    ignoreInput: true
  }), /*#__PURE__*/React.createElement(Shortcut, {
    held: [['Meta', 'Control']],
    ordered: ['n'],
    onMatch: () => setShowAddTicket(true),
    ignoreInput: true
  }));
};
export default /*#__PURE__*/memo(GetHelp);